<template>
  <v-container class="mt-10">
    <v-row>
      <v-col sm="3" md="6">
        <h1>Record Attachment Requests</h1>
        <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <hr />
    <v-row>
      <v-col cols="6">
        <v-btn-toggle
          v-model="tableDisplay"
          tile
          color="deep-purple accent-3"
          group
          class="text-center"
          rounded
          mandatory
        >
          <v-btn value="Pending" @click="selected = []"> Pending </v-btn>
          <v-btn value="Approved" @click="selected = []"> Approved </v-btn>
          <v-btn value="Rejected" @click="selected = []"> Rejected </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="selected.length > 0 && tableDisplay == 'Pending'">
        <v-app-bar color="grey darken-3" dense dark>
          <v-toolbar-title class="overline"
            >{{ selected.length }} selected</v-toolbar-title
          >
          <v-divider class="mx-4" vertical></v-divider>
          <v-btn
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="seeDetails()"
            >See Details</v-btn
          >

          <v-btn
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="approveRequestBtn()"
            >Approve</v-btn
          >

          <v-btn
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="rejectRequestBtn()"
            >Reject</v-btn
          >
        </v-app-bar>
      </v-col>
    </v-row>
    <v-row v-if="tableDisplay == 'Pending'">
      <v-col>
        <v-data-table
          show-select
          v-model="selected"
          :single-select="false"
          :headers="headers"
          :items="getRouteRequests"
          :items-per-page="5"
          class="elevation-2"
          item-key="id"
          :search="search"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-else-if="tableDisplay == 'Approved'">
      <v-col>
        <v-data-table
          show-select
          v-model="selected"
          :single-select="false"
          :headers="headers"
          :items="getApprovedRequests"
          :items-per-page="5"
          class="elevation-2"
          item-key="id"
          :search="search"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-else-if="tableDisplay == 'Rejected'">
      <v-col>
        <v-data-table
          show-select
          v-model="selected"
          :single-select="false"
          :headers="headers"
          :items="getRejectedRequests"
          :items-per-page="5"
          class="elevation-2"
          item-key="id"
          :search="search"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <!-- <v-snackbar v-model="snackbar" :timeout="timeout" class="pb-10">
      This action requires you to select only one route

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar> -->
    <v-dialog v-model="details_dialog" width="500">
      <v-card>
        <v-card-title class="headline lighten-2">
          Request Details
        </v-card-title>

        <v-card-text>
          <p class="mb-1">From: {{ user_messaged }}</p>
          <v-textarea outlined readonly :value="selected_message"></v-textarea>
          <!-- {{ selected_message }} -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="details_dialog = false">
            Close
          </v-btn>
          <v-btn color="indigo" text @click="approveRecordRequest">
            Approve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="reject_request_dialog" width="500">
      <v-card>
        <v-card-title class="headline lighten-2">
          Reject Record Request
        </v-card-title>

        <v-card-text>
          <p class="mb-1">From: {{ user_messaged }}</p>
          <v-textarea
            outlined
            v-model="remarks"
            placeholder="Tell the assigned user why you rejected the request for route attachment"
          ></v-textarea>
          <!-- {{ selected_message }} -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="reject_request_dialog = false">
            Close
          </v-btn>
          <v-btn color="indigo" text @click="rejectRecordRequest()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AttachRecordModal
      :dialog="route_record_dialog"
      :routeId="route_record_select"
      :routeType="route_record_type"
      :requestId="selected_request_id"
      @closeDialog="closeRouteRecordsModal"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

import AttachRecordModal from "../../components/records/AttachRecordModal";

export default {
  name: "RouteRecordRequests",
  components: {
    AttachRecordModal,
  },
  data() {
    return {
      tableDisplay: "Pending",
      search: "",
      selected: [],
      headers: [
        {
          text: "Initiator",
          align: "start",
          sortable: true,
          value: "initiator_name",
        },
        { text: "Action/Subject", value: "action_subject" },
        { text: "Route Type", value: "route_type" },
        { text: "User Assigned", value: "user_assigned" },
        { text: "Status", value: "status" },
        { text: "Date Requested", value: "dateRequested" },
      ],
      details_dialog: false,
      selected_message: "",
      user_messaged: "",
      route_record_dialog: false,
      route_record_select: null,
      route_record_type: "mainroute",
      selected_request_id: null,
      reject_request_dialog: false,
      remarks: "",
    };
  },
  methods: {
    ...mapActions(["fetchRouteRequests", "rejectRouteRequest"]),
    seeDetails() {
      if (this.selected.length > 1) {
        alert("must select only one");
      } else {
        this.details_dialog = true;
        this.selected_message = this.selected[0].message;
        this.user_messaged = this.selected[0].user_assigned;
        this.route_record_select = this.selected[0].isInitiatorRoute
          ? this.selected[0].route_id
          : this.selected[0].user_route_assignment_id;
        this.route_record_type = this.selected[0].isInitiatorRoute
          ? "mainroute"
          : "secondaryroute";
        this.selected_request_id = this.selected[0].id;
      }
    },
    approveRecordRequest() {
      this.route_record_dialog = true;
    },
    closeRouteRecordsModal() {
      this.route_record_dialog = false;
      Swal.fire(
        "Request Approved!",
        "Selected records have been attached",
        "success"
      );
      this.details_dialog = false;
      this.selected_message = "";
      this.user_messaged = "";
      this.route_record_select = null;
      this.selected_request_id = null;
      this.selected = [];
    },
    approveRequestBtn() {
      this.route_record_dialog = true;
      this.route_record_select = this.selected[0].isInitiatorRoute
        ? this.selected[0].route_id
        : this.selected[0].user_route_assignment_id;
      this.route_record_type = this.selected[0].isInitiatorRoute
        ? "mainroute"
        : "secondaryroute";
      this.selected_request_id = this.selected[0].id;
    },
    rejectRequestBtn() {
      this.reject_request_dialog = true;
    },
    rejectRecordRequest() {
      const body = {
        request_id: this.selected[0].id,
        route_type: this.selected[0].isInitiatorRoute
          ? "mainroute"
          : "secondaryroute",
        remarks: this.remarks,
      };

      this.rejectRouteRequest(body).then(() => {
        Swal.fire(
          "Request Rejected",
          "Selected record request has been rejected",
          "success"
        );

        this.remarks = "";
        this.reject_request_dialog = false;
        this.selected = [];
      });
    },
  },
  computed: mapGetters(["getRouteRequests", "getApprovedRequests", "getRejectedRequests"]),
  created() {
    this.fetchRouteRequests();
  },
};
</script>

<style></style>
